import {
  addProductToCart,
  updateQuantityOfProductInCart,
} from 'store/modules/cart';
import { getGACartItemsParams } from './gtag';

export function createDebouncedDecrementHandler({
  quantity,
  item,
  dispatch,
  timeoutRef,
  delay = 800,
}) {
  return () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      const action = {
        sku: item.codigo,
        quantity: quantity === 1 ? 0 : quantity - 1,
        showAfterRequest: false,
        GA: getGACartItemsParams({
          product: item,
          qty: quantity === 1 ? quantity : 1,
          remove: true,
        }),
      };

      dispatch(updateQuantityOfProductInCart(action));
    }, delay);
  };
}

export function createIncrementHandler({ item, dispatch }) {
  return () => {
    dispatch(
      addProductToCart({
        sku: item.codigo,
        quantity: 1,
        showAfterRequest: false,
        GA: getGACartItemsParams({ product: item, qty: 1 }),
      }),
    );
  };
}
